const page = {
  terms: 'terms'
}

export default {
  event: {
    'j-close-terms': [
      {
        type: 'click',
        event: 'click-close-terms-btn'
      }
    ],
    'j-agree': [
      {
        type: 'click',
        event: 'click-agree-btn'
      }
    ],
    'j-agree-all': [
      {
        type: 'click',
        event: 'click-agree-all-btn'
      }
    ],
    'j-check': [
      {
        type: 'click',
        event: 'click-check-btn'
      }
    ],
    'j-look-detail': [
      {
        type: 'click',
        event: 'click-look-detail-item'
      }
    ],
    'j-close-tip-close': [
      {
        type: 'click',
        event: 'click-close-tip-close-btn'
      }
    ],
    'j-close-tip-sure': [
      {
        type: 'click',
        event: 'click-close-tip-sure-btn'
      }
    ],
    'j-back': [
      {
        type: 'click',
        event: 'click-back-btn'
      }
    ]
  },
  enter: {
    terms: { event: page.terms }
  },
  router: {
    terms: { event: page.terms }
  }
}
